import { brandCode } from 'constants/brandCodes';
import { ER_OFFLINE_FEE, OFFLINE_FEE } from 'types/fees';

const Fare = {
  offlineFee: (fare) => {
    const esOfflineFee = fare.fees.find((fee) => fee.code === OFFLINE_FEE);
    const erOfflineFee = fare.fees.find((fee) => fee.code === ER_OFFLINE_FEE);

    const offlineFee = esOfflineFee || erOfflineFee;

    return offlineFee ? { ...offlineFee, __typename: 'OfflineFee' } : null;
  },
  isLyria: (fare) => fare.legs.some((leg) => leg?.serviceType?.brandCode === brandCode.Lyria)
};

export default Fare;
